import axios from "axios";
import i18next from "i18next";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { useAuth } from "../../auth";

import "./header2.css";
// import "./header.css"

import EN from "../../images/flags/en-flag.png";
import FR from "../../images/flags/fr-flag.png";

// const py_test_account = process.env.REACT_APP_PY_TEST_ACCOUNT
// const henri_test_account = process.env.REACT_APP_HENRI_TEST_ACCOUNT
// const dreem_test_account = process.env.REACT_APP_DREEM_TEST_ACCOUNT

const Header = (props) => {
  const { authTokens } = useAuth();
  const { setAuthTokens } = useAuth();
  const history = useHistory();

  const { t } = useTranslation(["header"]);
  const isAdmin = authTokens.user_admin;

  const headers = {
    Authorization: authTokens.token,
  };

  const currentPlan = Number(authTokens.plan);

  const [profileMenu, setProfileMenu] = useState(false);
  const showProfileMenu = () => {
    setProfileMenu(!profileMenu);
  };

  const goToPlans = () => {
    history.push({ pathname: "/plans" });
  };

  // const [notificationList, setNotificationList] = useState([]);
  // const [unreadNotifications, setUnreadNotifications] = useState(0);
  // const [showNotifications, setShowNotifications] = useState(false)
  // const displayNotifications = () => {
  //     if (showNotifications && unreadNotifications > 0) {
  //         // setNotificationList(notificationList.map(notif => ({ ...notif, isRead: true })));
  //         // setUnreadNotifications(0);
  //         updateNotificationsServer();
  //     }
  //     setShowNotifications(!showNotifications);
  // }

  const changeLanguage = (lng_code) => {
    i18next.changeLanguage(lng_code);
    setProfileMenu(false);
  };

  // const current_language = i18n.language;

  const signout = () => {
    setAuthTokens({});
  };

  // const updateNotificationsServer = async () => {

  //     let updated_notifications = notificationList.map(notif => ({ ...notif, isRead: true }));

  //     const payload = {
  //         user_id: authTokens.user_id,
  //         updated_notifications_array: updated_notifications
  //     }

  //     axios.post(process.env.REACT_APP_SOCIALPIKA_API_URL + "/notification/update_user_notifications/", payload, {
  //         headers: headers,
  //     }).then(() => {
  //         setNotificationList(updated_notifications);
  //         setUnreadNotifications(0);
  //     })
  //         .catch(() => {
  //         });
  // }

  // const fetchNotifications = async () => {
  //     const payload = {
  //         user_id: authTokens.user_id
  //     }

  //     axios.post(process.env.REACT_APP_SOCIALPIKA_API_URL + "/notification/get_global_notificatons_for_user/", payload, {
  //         headers: headers,
  //     }).then((response) => {
  //         setNotificationList(response.data);
  //         let unread_notif = 0;
  //         response.data.map(notification => {
  //             if (!notification.isRead) unread_notif++;
  //         })
  //         setUnreadNotifications(unread_notif);
  //     })
  //         .catch(() => {
  //         });
  // }

  const fetchCurrentUsage = async () => {
    const payload = {
      company_id: authTokens.account_id,
      user_id: authTokens.user_id,
    };

    axios
      .post(
        process.env.REACT_APP_SOCIALPIKA_API_URL + "/user/get_current_usage/",
        payload,
        {
          headers: headers,
        },
      )
      .then((response) => {
        setAuthTokens({
          ...authTokens,
          cai: response.data.content_ai,
          strc: response.data.strc,
        });
        setPublicationsRatio(response.data.quotaRatioPublications);
        setPublicationsRatioPercent(
          response.data.quotaRatioPublicationsPercent > 100
            ? 100
            : response.data.quotaRatioPublicationsPercent,
        );
        // setCreditsRatio(response.data.credits_used + '/' + response.data.credits_allowed);
        // setCreditsRatioPercent(Math.round(response.data.credits_used / response.data.credits_allowed * 100) > 100 ? 100 : Math.round(response.data.credits_used / response.data.credits_allowed * 100));
      })
      .catch(() => {});
  };

  const [publicationsRatio, setPublicationsRatio] = useState("");
  // const [creditsRatio, setCreditsRatio] = useState('');
  const [publicationsRatioPercent, setPublicationsRatioPercent] = useState(0);
  // const [creditsRatioPercent, setCreditsRatioPercent] = useState(0);

  const checkGaugeStyle = (ratio) => {
    let style = "";

    if (ratio > 90) {
      style = "meter meter_small meter_red";
    } else if (ratio > 80) {
      style = "meter meter_small meter_yellow";
    } else {
      style = "meter meter_small meter_green";
    }

    return style;
  };

  useEffect(() => {
    // fetchNotifications();
    fetchCurrentUsage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchCurrentUsage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.reloadHeaderData]);

  return (
    <header>
      <div className="header_wrapper">
        <div className="brand">
          <Link to="/">
            <svg viewBox="0 0 911 258" fill="none">
              <circle
                cx="128.97"
                cy="128.97"
                r="117.97"
                fill="white"
                stroke="white"
                strokeWidth="22"
              />
              <path
                d="M53.5753 152.104V213.802L203.335 213.811V152.104C203.335 134.269 197.145 117.896 186.817 105V62.342H186.823C186.823 52.0431 178.517 43.6956 168.266 43.6956C158.012 43.6956 149.701 52.0431 149.701 62.342V79.9685C142.969 77.9694 135.838 76.877 128.459 76.877C121.075 76.877 113.948 77.9671 107.212 79.9685V62.342C107.212 52.0431 98.9005 43.6956 88.6515 43.6956C78.4003 43.6956 70.0892 52.0431 70.0892 62.342V105.002C59.7658 117.896 53.5753 134.269 53.5753 152.104Z"
                fill="white"
              />
              <path
                d="M88.9312 132.841C93.9997 132.841 98.1085 128.713 98.1085 123.621C98.1085 118.529 93.9997 114.401 88.9312 114.401C83.8626 114.401 79.7538 118.529 79.7538 123.621C79.7538 128.713 83.8626 132.841 88.9312 132.841Z"
                fill="#3D2BFF"
              />
              <path
                d="M167.991 132.841C173.059 132.841 177.168 128.713 177.168 123.621C177.168 118.529 173.059 114.401 167.991 114.401C162.922 114.401 158.813 118.529 158.813 123.621C158.813 128.713 162.922 132.841 167.991 132.841Z"
                fill="#3D2BFF"
              />
              <path
                d="M107.085 154.441C105.804 153.149 103.724 153.149 102.442 154.441C101.159 155.733 101.159 157.818 102.442 159.11C109.391 166.093 118.629 169.935 128.458 169.935C138.281 169.935 147.522 166.093 154.47 159.11C155.76 157.82 155.76 155.735 154.475 154.441C153.193 153.149 151.113 153.149 149.827 154.441C144.893 159.393 138.577 162.417 131.743 163.153V150.887C134.202 149.672 135.899 147.132 135.899 144.181C135.899 140.058 132.564 136.703 128.458 136.703C124.343 136.703 121.014 140.056 121.014 144.181C121.014 147.132 122.71 149.672 125.169 150.887V163.153C118.342 162.415 112.017 159.391 107.085 154.441Z"
                fill="#3D2BFF"
              />
              <path
                d="M128.461 15.5866C66.1209 15.5866 15.5866 66.3559 15.5866 128.986C15.5866 162.738 30.2822 193.03 53.5753 213.802V152.104C53.5753 134.269 59.7658 117.896 70.0892 105.002V62.342C70.0892 52.0431 78.4003 43.6956 88.6515 43.6956C98.9005 43.6956 107.212 52.0431 107.212 62.342V79.9685C113.948 77.9671 121.075 76.877 128.459 76.877C135.838 76.877 142.969 77.9694 149.701 79.9685V62.342C149.701 52.0431 158.012 43.6956 168.266 43.6956C178.517 43.6956 186.823 52.0431 186.823 62.342H186.817V105C197.145 117.896 203.335 134.269 203.335 152.104V213.811C226.635 193.039 241.335 162.745 241.335 128.986C241.335 66.3559 190.801 15.5866 128.461 15.5866Z"
                fill="url(#paint0_linear_1_36)"
              />
              <path
                d="M343.92 163.84C337.76 163.84 332.24 162.84 327.36 160.84C322.48 158.84 318.56 155.88 315.6 151.96C312.72 148.04 311.2 143.32 311.04 137.8H332.88C333.2 140.92 334.28 143.32 336.12 145C337.96 146.6 340.36 147.4 343.32 147.4C346.36 147.4 348.76 146.72 350.52 145.36C352.28 143.92 353.16 141.96 353.16 139.48C353.16 137.4 352.44 135.68 351 134.32C349.64 132.96 347.92 131.84 345.84 130.96C343.84 130.08 340.96 129.08 337.2 127.96C331.76 126.28 327.32 124.6 323.88 122.92C320.44 121.24 317.48 118.76 315 115.48C312.52 112.2 311.28 107.92 311.28 102.64C311.28 94.8 314.12 88.68 319.8 84.28C325.48 79.8 332.88 77.56 342 77.56C351.28 77.56 358.76 79.8 364.44 84.28C370.12 88.68 373.16 94.84 373.56 102.76H351.36C351.2 100.04 350.2 97.92 348.36 96.4C346.52 94.8 344.16 94 341.28 94C338.8 94 336.8 94.68 335.28 96.04C333.76 97.32 333 99.2 333 101.68C333 104.4 334.28 106.52 336.84 108.04C339.4 109.56 343.4 111.2 348.84 112.96C354.28 114.8 358.68 116.56 362.04 118.24C365.48 119.92 368.44 122.36 370.92 125.56C373.4 128.76 374.64 132.88 374.64 137.92C374.64 142.72 373.4 147.08 370.92 151C368.52 154.92 365 158.04 360.36 160.36C355.72 162.68 350.24 163.84 343.92 163.84ZM413.548 163.96C406.988 163.96 401.068 162.56 395.788 159.76C390.588 156.96 386.468 152.96 383.428 147.76C380.468 142.56 378.988 136.48 378.988 129.52C378.988 122.64 380.508 116.6 383.548 111.4C386.588 106.12 390.748 102.08 396.028 99.28C401.308 96.48 407.228 95.08 413.788 95.08C420.348 95.08 426.268 96.48 431.548 99.28C436.828 102.08 440.988 106.12 444.028 111.4C447.068 116.6 448.588 122.64 448.588 129.52C448.588 136.4 447.028 142.48 443.908 147.76C440.868 152.96 436.668 156.96 431.308 159.76C426.028 162.56 420.108 163.96 413.548 163.96ZM413.548 146.2C417.468 146.2 420.788 144.76 423.508 141.88C426.308 139 427.708 134.88 427.708 129.52C427.708 124.16 426.348 120.04 423.628 117.16C420.988 114.28 417.708 112.84 413.788 112.84C409.788 112.84 406.468 114.28 403.828 117.16C401.188 119.96 399.868 124.08 399.868 129.52C399.868 134.88 401.148 139 403.708 141.88C406.348 144.76 409.628 146.2 413.548 146.2ZM451.194 129.52C451.194 122.56 452.594 116.48 455.394 111.28C458.274 106.08 462.234 102.08 467.274 99.28C472.394 96.48 478.234 95.08 484.794 95.08C493.194 95.08 500.194 97.28 505.794 101.68C511.474 106.08 515.194 112.28 516.954 120.28H495.114C493.274 115.16 489.714 112.6 484.434 112.6C480.674 112.6 477.674 114.08 475.434 117.04C473.194 119.92 472.074 124.08 472.074 129.52C472.074 134.96 473.194 139.16 475.434 142.12C477.674 145 480.674 146.44 484.434 146.44C489.714 146.44 493.274 143.88 495.114 138.76H516.954C515.194 146.6 511.474 152.76 505.794 157.24C500.114 161.72 493.114 163.96 484.794 163.96C478.234 163.96 472.394 162.56 467.274 159.76C462.234 156.96 458.274 152.96 455.394 147.76C452.594 142.56 451.194 136.48 451.194 129.52ZM534.051 89.08C530.451 89.08 527.491 88.04 525.171 85.96C522.931 83.8 521.811 81.16 521.811 78.04C521.811 74.84 522.931 72.2 525.171 70.12C527.491 67.96 530.451 66.88 534.051 66.88C537.571 66.88 540.451 67.96 542.691 70.12C545.011 72.2 546.171 74.84 546.171 78.04C546.171 81.16 545.011 83.8 542.691 85.96C540.451 88.04 537.571 89.08 534.051 89.08ZM544.251 96.04V163H523.731V96.04H544.251ZM550.841 129.4C550.841 122.52 552.121 116.48 554.681 111.28C557.321 106.08 560.881 102.08 565.361 99.28C569.841 96.48 574.841 95.08 580.361 95.08C585.081 95.08 589.201 96.04 592.721 97.96C596.321 99.88 599.081 102.4 601.001 105.52V96.04H621.521V163H601.001V153.52C599.001 156.64 596.201 159.16 592.601 161.08C589.081 163 584.961 163.96 580.241 163.96C574.801 163.96 569.841 162.56 565.361 159.76C560.881 156.88 557.321 152.84 554.681 147.64C552.121 142.36 550.841 136.28 550.841 129.4ZM601.001 129.52C601.001 124.4 599.561 120.36 596.681 117.4C593.881 114.44 590.441 112.96 586.361 112.96C582.281 112.96 578.801 114.44 575.921 117.4C573.121 120.28 571.721 124.28 571.721 129.4C571.721 134.52 573.121 138.6 575.921 141.64C578.801 144.6 582.281 146.08 586.361 146.08C590.441 146.08 593.881 144.6 596.681 141.64C599.561 138.68 601.001 134.64 601.001 129.52ZM652.687 74.2V163H632.167V74.2H652.687Z"
                fill="#222C37"
              />
              <path
                d="M728.64 105.88C728.64 110.76 727.52 115.24 725.28 119.32C723.04 123.32 719.6 126.56 714.96 129.04C710.32 131.52 704.56 132.76 697.68 132.76H684.96V163H664.44V78.76H697.68C704.4 78.76 710.08 79.92 714.72 82.24C719.36 84.56 722.84 87.76 725.16 91.84C727.48 95.92 728.64 100.6 728.64 105.88ZM696.12 116.44C700.04 116.44 702.96 115.52 704.88 113.68C706.8 111.84 707.76 109.24 707.76 105.88C707.76 102.52 706.8 99.92 704.88 98.08C702.96 96.24 700.04 95.32 696.12 95.32H684.96V116.44H696.12ZM745.443 89.08C741.843 89.08 738.883 88.04 736.563 85.96C734.323 83.8 733.203 81.16 733.203 78.04C733.203 74.84 734.323 72.2 736.563 70.12C738.883 67.96 741.843 66.88 745.443 66.88C748.963 66.88 751.843 67.96 754.083 70.12C756.403 72.2 757.563 74.84 757.563 78.04C757.563 81.16 756.403 83.8 754.083 85.96C751.843 88.04 748.963 89.08 745.443 89.08ZM755.643 96.04V163H735.123V96.04H755.643ZM807.233 163L786.833 134.92V163H766.313V74.2H786.833V123.28L807.113 96.04H832.433L804.593 129.64L832.673 163H807.233ZM832.213 129.4C832.213 122.52 833.493 116.48 836.053 111.28C838.693 106.08 842.253 102.08 846.733 99.28C851.213 96.48 856.213 95.08 861.733 95.08C866.453 95.08 870.573 96.04 874.093 97.96C877.693 99.88 880.453 102.4 882.373 105.52V96.04H902.893V163H882.373V153.52C880.373 156.64 877.573 159.16 873.973 161.08C870.453 163 866.333 163.96 861.613 163.96C856.173 163.96 851.213 162.56 846.733 159.76C842.253 156.88 838.693 152.84 836.053 147.64C833.493 142.36 832.213 136.28 832.213 129.4ZM882.373 129.52C882.373 124.4 880.933 120.36 878.053 117.4C875.253 114.44 871.813 112.96 867.733 112.96C863.653 112.96 860.173 114.44 857.293 117.4C854.493 120.28 853.093 124.28 853.093 129.4C853.093 134.52 854.493 138.6 857.293 141.64C860.173 144.6 863.653 146.08 867.733 146.08C871.813 146.08 875.253 144.6 878.053 141.64C880.933 138.68 882.373 134.64 882.373 129.52Z"
                fill="url(#paint1_linear_1_36)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1_36"
                  x1="128.468"
                  y1="235.871"
                  x2="128.468"
                  y2="15.5866"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#3D2BFF" />
                  <stop offset="1" stopColor="#19A4FE" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_1_36"
                  x1="657"
                  y1="121"
                  x2="911"
                  y2="121"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#3D2BFF" />
                  <stop offset="1" stopColor="#19A4FE" />
                </linearGradient>
              </defs>
            </svg>
          </Link>
          <span className="brand_badge">v2</span>
        </div>
        <div className="row centered h-100">
          {currentPlan === 0 ? (
            <div role="button" tabIndex={0} className="current_plan" onClick={() => goToPlans()}>
              <div className="plan_details">
                <p className="text-bold">{t("basic_plan")}</p>
              </div>
              <span className="upgrade">
                (
                <svg viewBox="0 0 48 48">
                  <path
                    fill="current"
                    d="m11 39.6 5.3-2.15q-.65-1.9-1.125-3.85-.475-1.95-.825-3.95L11 31.9Zm8.3-2.6h9.4q1.1-2.95 1.7-5.875Q31 28.2 31 26q0-5.75-1.65-10.1T24 7.65q-3.7 3.9-5.35 8.25Q17 20.25 17 26q0 2.2.6 5.125T19.3 37ZM24 25.5q-1.45 0-2.475-1.025Q20.5 23.45 20.5 22q0-1.45 1.025-2.475Q22.55 18.5 24 18.5q1.45 0 2.475 1.025Q27.5 20.55 27.5 22q0 1.45-1.025 2.475Q25.45 25.5 24 25.5Zm13 14.1v-7.7l-3.35-2.25q-.35 2-.825 3.95-.475 1.95-1.125 3.85ZM24 3.55q5.1 4.5 7.55 9.975T34 26v.25l4.65 3.15q.65.4 1 1.05t.35 1.4V44l-10-4H18L8 44V31.85q0-.75.35-1.4.35-.65 1-1.05L14 26.25V26q0-7 2.45-12.475T24 3.55Z"
                  />
                </svg>
                {t("upgrade")})
              </span>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="profile">
          <div className="margin-s1">
            <p className="p-no-margin p-mini text-grey">
              {publicationsRatio} {t("monthly_publications")}
            </p>
            <div className={checkGaugeStyle(publicationsRatioPercent)}>
              <span style={{ width: publicationsRatioPercent + "%" }}></span>
            </div>
          </div>
          {authTokens.plan > 0 ? (
            <div role="button" tabIndex={0} className="current_plan" onClick={() => goToPlans()}>
              <div className="plan_details">
                <p className="text-bold">
                  {authTokens.cai ? t("growth_plan") : t("organic_plan")}
                </p>
              </div>
            </div>
          ) : (
            ""
          )}

          <div
            className={
              isAdmin
                ? "profile_icon profile_blue border-gradient-blue"
                : "profile_icon profile_green border-gradient-green"
            }
          >
            {authTokens.user_profile_url ? (
              <img
                src={authTokens.user_profile_url}
                alt={authTokens.user_first_name + " " + authTokens.name}
              />
            ) : (
              authTokens.initials
            )}
          </div>
          <svg role="button" tabIndex={0}
            className="chevron"
            viewBox="0 0 24 24"
            onClick={showProfileMenu}
          >
            <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
          </svg>
          <div
            className={profileMenu ? "profile_menu" : "profile_menu inactive"}
          >
            <ul>
              <Link to="/sm_accounts" className="profile_menu_mobile_only" onClick={() => setProfileMenu(false)}>
                <li>
                  <svg viewBox="0 0 24 24">
                    <path
                      fill="current"
                      d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                    />
                  </svg>
                  <p className="p-small">{t("manage_accounts", { defaultValue: "Manage accounts" })}</p>
                </li>
              </Link>
              <Link to="/account" onClick={() => setProfileMenu(false)}>
                <li>
                  <svg viewBox="0 0 24 24">
                    <path
                      fill="current"
                      d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
                    />
                  </svg>
                  <p className="p-small">{t("account")}</p>
                </li>
              </Link>
              <Link to="/plans" onClick={() => setProfileMenu(false)}>
                <li>
                  <svg viewBox="0 0 48 48">
                    <path
                      fill="current"
                      d="m11 39.6 5.3-2.15q-.65-1.9-1.125-3.85-.475-1.95-.825-3.95L11 31.9Zm8.3-2.6h9.4q1.1-2.95 1.7-5.875Q31 28.2 31 26q0-5.75-1.65-10.1T24 7.65q-3.7 3.9-5.35 8.25Q17 20.25 17 26q0 2.2.6 5.125T19.3 37ZM24 25.5q-1.45 0-2.475-1.025Q20.5 23.45 20.5 22q0-1.45 1.025-2.475Q22.55 18.5 24 18.5q1.45 0 2.475 1.025Q27.5 20.55 27.5 22q0 1.45-1.025 2.475Q25.45 25.5 24 25.5Zm13 14.1v-7.7l-3.35-2.25q-.35 2-.825 3.95-.475 1.95-1.125 3.85ZM24 3.55q5.1 4.5 7.55 9.975T34 26v.25l4.65 3.15q.65.4 1 1.05t.35 1.4V44l-10-4H18L8 44V31.85q0-.75.35-1.4.35-.65 1-1.05L14 26.25V26q0-7 2.45-12.475T24 3.55Z"
                    />
                  </svg>
                  <p className="p-small">{t("plans")}</p>
                </li>
              </Link>
              <Link to="/news" onClick={() => setProfileMenu(false)}>
                <li>
                  <svg viewBox="0 0 24 24">
                    <path
                      fill="current"
                      d="M18,13H17.32L15.32,15H17.23L19,17H5L6.78,15H8.83L6.83,13H6L3,16V20A2,2 0 0,0 5,22H19A2,2 0 0,0 21,20V16L18,13M17,7.95L12.05,12.9L8.5,9.36L13.46,4.41L17,7.95M12.76,2.29L6.39,8.66C6,9.05 6,9.68 6.39,10.07L11.34,15C11.73,15.41 12.36,15.41 12.75,15L19.11,8.66C19.5,8.27 19.5,7.64 19.11,7.25L14.16,2.3C13.78,1.9 13.15,1.9 12.76,2.29Z"
                    />
                  </svg>
                  <p className="p-small">{t("upcoming_features")}</p>
                </li>
              </Link>
              <Link to="/affiliates" onClick={() => setProfileMenu(false)}>
                <li>
                  <svg viewBox="0 0 24 24">
                    <path
                      fill="current"
                      d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z"
                    />
                  </svg>
                  <p className="p-small">{t("affiliate_program")}</p>
                </li>
              </Link>
              <li className="language_selection">
                <img
                  src={EN}
                  alt="English"
                  onClick={(e) => {
                    changeLanguage("en");
                  }}
                />
                <img
                  src={FR}
                  alt="Français"
                  onClick={(e) => {
                    changeLanguage("fr");
                  }}
                />
                {/* <p className="p-small" onClick={e => { changeLanguage('en') }}>EN</p> */}
                {/* <p className="p-small" onClick={e => { changeLanguage('fr') }}>FR</p> */}
              </li>
              <li role="button" tabIndex={0} onClick={signout} className="signout">
                <svg viewBox="0 0 24 24">
                  <path
                    fill="current"
                    d="M22 12L18 8V11H10V13H18V16M20 18A10 10 0 1 1 20 6H17.27A8 8 0 1 0 17.27 18Z"
                  />
                </svg>
                <p className="p-small text-red">{t("signout")}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
